import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'jv',
  months: [
    'Januari',
    'Februari',
    'Maret',
    'April',
    'Mei',
    'Juni',
    'Juli',
    'Agustus',
    'September',
    'Oktober',
    'November',
    'Desember',
  ],
  monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Agt', 'Sep', 'Okt', 'Nov', 'Des'],
  weekdays: ['Minggu', 'Senen', 'Selasa', 'Rebo', 'Kemis', 'Jemuwah', 'Setu'],
  weekdaysMin: ['Min', 'Sen', 'Sel', 'Re', 'Ke', 'Je', 'Se'],
  weekdaysShort: ['Ming', 'Sen', 'Sel', 'Reb', 'Kem', 'Jem', 'Set'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'HH:mm',
    lts: 'HH:mm:ss',
    L: 'DD/MM/YYYY',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY [pukul] HH.mm',
    'LLL-Y': 'D MMMM HH.mm',
    LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
    'LLLL-Y': 'dddd, D MMMM  HH.mm',
    l: 'D/M/YYYY',
    'l-Y': 'D/M',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    lll: 'D MMM YYYY h:mm A',
    'lll-Y': 'D MMM h:mm A',
    llll: 'ddd, D MMM YYYY h:mm A',
    'llll-Y': 'ddd, D MMM h:mm A',
    'll-Y+w': 'ddd, D MMM',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'D MMMM YYYY HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'am', pm: 'pm', AM: 'AM', PM: 'PM' },
  past: {
    y: { other: '%s taun kepungkur' },
    M: { other: '%s sasi kepungkur' },
    w: { other: '%s pekan kepungkur' },
    d: { other: '%s dina kepungkur' },
    h: { other: '%s jam kepungkur' },
    m: { other: '%s menit kepungkur' },
    s: { other: '%s detik kepungkur' },
  },
  future: {
    y: { other: 'ing %s taun' },
    M: { other: 'ing %s sasi' },
    w: { other: 'ing %s pekan' },
    d: { other: 'ing %s dina' },
    h: { other: 'ing %s jam' },
    m: { other: 'ing %s menit' },
    s: { other: 'ing %s detik' },
  },
  abbr: {
    y: { other: '%stn.' },
    M: { other: '%ss' },
    w: { other: '%smgg' },
    d: { other: '%sdn' },
    h: { other: '%sj' },
    m: { other: '%smnt' },
    s: { other: '%sdtk' },
  },
  justNow: 'lagi wae',
  yesterday: 'Wingi',
  today: 'Dina Iki',
  tomorrow: 'Sesuk',
  weekStart: 0,
};
const localeName: LocaleName = 'jv';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'am' : 'AM';
    } else {
      return isLowerCase ? 'pm' : 'PM';
    }
  },
};
